module.exports = __webpack_public_path__ + "static/media/top-img_5.4fcf346e.png";